import {useSelector} from 'react-redux';
import {Selector} from '../../state/selector';
import {Alert, Box, CircularProgress} from '@mui/material';
import WebsiteCheck from './WebsiteCheck';
import StartWebsiteCheckInfo from './StartWebsiteCheckInfo';
import WebsiteCheckOverview from './WebsiteCheckOverview';
import WebsiteCheckHeader from './WebsiteCheckHeader';

const styles = {
    root: {
        boxSizing: 'border-box',
        height: '100%',
        overflowY: 'auto',
    },
};

const WebsiteCheckPage = () => {
    const isAdmin = useSelector(Selector.User.isAdmin);
    const hasTesterCompanyAccess = useSelector(Selector.User.hasTesterCompanyAccess);
    const websiteCheckLoaded = useSelector(Selector.WebsiteCheck.loaded);
    const websiteCheckId = useSelector(Selector.WebsiteCheck.websiteCheckId);
    const activeVersion = useSelector(Selector.QuestionList.activeVersion);
    const viewingVersion = useSelector(Selector.QuestionList.viewingVersion);
    const isViewingOldVersion = viewingVersion !== activeVersion;

    if (hasTesterCompanyAccess) {
        return <WebsiteCheckOverview />;
    }

    if (isAdmin) {
        return (
            <Box sx={styles.root}>
                <WebsiteCheckHeader title={'Website Check'} />

                {!websiteCheckLoaded && <CircularProgress size={24} sx={{ mt: 2 }} />}
                {(websiteCheckLoaded && websiteCheckId) && <WebsiteCheck />}
                {(websiteCheckLoaded && !websiteCheckId && !isViewingOldVersion) && <StartWebsiteCheckInfo />}
                {(websiteCheckLoaded && !websiteCheckId && isViewingOldVersion) && (
                    <Alert severity={'info'}>
                        Kein Website-Check für Version {viewingVersion} vorhanden.
                    </Alert>
                )}
            </Box>
        );
    } else {
        return null;
    }
};

export default WebsiteCheckPage;
